export const buildEntityPayload = (entityKey, payload = {}) => ({
  [entityKey]: payload,
});

export const buildPaginatedEntityPayload = (
  entityKey,
  params = {},
  extraPayload = {}
) =>
  buildEntityPayload(entityKey, {
    ...extraPayload,
    limit: params?.limit,
    offSet: params?.offSet,
  });

export const buildSearchEntityPayload = (
  entityKey,
  params = {},
  extraPayload = {}
) =>
  buildPaginatedEntityPayload(entityKey, params, {
    ...extraPayload,
    name: params?.name,
  });

export const pickEntityFields = (params = {}, fieldMap = []) => {
  if (Array.isArray(fieldMap)) {
    return fieldMap.reduce((payload, field) => {
      payload[field] = params?.[field];
      return payload;
    }, {});
  }

  return Object.entries(fieldMap || {}).reduce((payload, [targetKey, sourceKey]) => {
    payload[targetKey] = params?.[sourceKey];
    return payload;
  }, {});
};

export const buildMutationEntityPayload = (
  entityKey,
  params = {},
  fieldMap = [],
  extraPayload = {}
) =>
  buildEntityPayload(entityKey, {
    ...pickEntityFields(params, fieldMap),
    ...extraPayload,
  });

export const buildSignalConfig = (params = {}) =>
  params?.signal ? { signal: params.signal } : undefined;
